// ----------------------------------------------------------------------

export const phoneNumber = [
  '(51) 95374-4961',
  '(51) 94966-2836',
  '(51) 99757-9909',
  '(51) 92767-2903',
  '(51) 90588-5716',
  '(51) 95439-2578',
  '(51) 96924-4058',
  '(51) 92917-1454',
  '(51) 95840-9338',
  '(51) 96269-2446',
  '(51) 93373-6253',
  '(51) 96509-8866',
  '(51) 91465-1954',
  '(51) 98295-9408',
  '(51) 91492-6028',
  '(51) 91699-7588',
  '(51) 90268-4826',
  '(51) 95952-3828',
  '(51) 92255-5190',
  '(51) 98439-8033',
  '(51) 92940-8266',
  '(51) 92685-8057',
  '(51) 93801-5212',
  '(51) 96285-8928',
  '(51) 92767-8621',
  '(51) 92830-0731',
  '(51) 94940-3166',
  '(51) 92702-2396',
  '(51) 96261-9789',
  '(51) 92390-5069',
  '(51) 93907-8334',
  '(51) 95347-2399',
  '(51) 99228-5604',
  '(51) 94452-2071',
  '(51) 97841-0447',
  '(51) 95619-2157',
  '(51) 93834-0373',
  '(51) 96880-2602',
  '(51) 96772-0722',
  '(51) 98615-3365,'
];
